import { stepName as changeStepName } from '../../../../components/process/generic/Consent/ChangeConsentWrapper'
import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const convertConsents = changeConsentData => {
  return changeConsentData.filter(consent => consent.selected)
    .map(consent => {
      return {
        consentType: consent.consentType,
        consentTextHash: consent.hash,
        selectedChannels: (consent.selectedAdChannels || []).map(channel => channel.adChannelType)
      }
    })
}

const ConsentModule = {
  namespaced: true,
  state: {
    step: changeStepName,
    newConsent: [],
    view: 'viewConsent'
  },
  actions: {
    async changeConsent ({ commit, state, getters }, { changeConsentData, nextStep }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation consent ($changeCustomerConsentsInput: ChangeCustomerConsentsInput!) {
          changeCustomerConsents (changeCustomerConsents: $changeCustomerConsentsInput) {
            success,
            transactionId
          }
        }`,
        variables: {
          changeCustomerConsentsInput: {
            updateConsents: convertConsents(changeConsentData)
          }
        },
        update: (cache) => {
          Object.keys(cache.data.data).forEach(key => {
            if (key.match(/customerConsents/)) {
              cache.data.delete(key)
            }
          })
        }
      }).then((response) => {
        commit('changeStep', nextStep)
        commit('changeView', 'consentChangeSuccess')
        document.getElementsByClassName('overview-process')[4].scrollIntoView({ behavior: 'smooth' })
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {
    changeStep (state, step) {
      state.step = step
    },
    changeView (state, newView) {
      state.view = newView
    },
    changeToEditView (state) {
      state.view = 'changeConsent'
    },
    changeToView (state) {
      state.view = 'viewConsent'
    }
  },
  getters: {
    getStep: state => {
      return state.step
    },
    getView: state => {
      return state.view
    },
    getCtaHidden: state => {
      return state.view === 'changeConsent'
    }
  }
}

export {
  ConsentModule
}
